export function getBrowserTimeZone() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone.trim() === '') {
        throw new Error('Browser time zone is required');
    }
    return timeZone;
}

export function getBrowserStartOfTodayEpochSecond() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.floor(today.getTime() / 1000);
}
